export default __webpack_public_path__ + "static/media/State Farm.c47e7fee.png";